import { render, staticRenderFns } from "./cargoOwner_mobile.vue?vue&type=template&id=b310dcf0&scoped=true&"
import script from "./cargoOwner_mobile.vue?vue&type=script&lang=js&"
export * from "./cargoOwner_mobile.vue?vue&type=script&lang=js&"
import style0 from "./cargoOwner_mobile.vue?vue&type=style&index=0&id=b310dcf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b310dcf0",
  null
  
)

export default component.exports